const CANCELLED_STATUSES = new Set(['rejected', 'cancelled', 'canceled'])

export const shipmentStatusLabel = (shipmentOrStatus) => {
  if (shipmentOrStatus && typeof shipmentOrStatus === 'object') {
    if (shipmentOrStatus.is_deleted || shipmentOrStatus.cancelled_at) return 'Cancelled'
    return shipmentStatusLabel(shipmentOrStatus.status)
  }
  const text = String(shipmentOrStatus || '').replace(/_/g, ' ').trim()
  if (CANCELLED_STATUSES.has(text.toLowerCase())) return 'Cancelled'
  return text
}
